import React from "react";
import { Layout } from "@/components/Layout";
import { PageHeader } from "@/components/PageHeader";
import { useListings } from "@/hooks/useListings";
import { useSave } from "@/hooks/useSave";
import { Bookmark, Clock } from "lucide-react";
import { toast } from "sonner";

const SelfCare = () => {
  const { save } = useSave();
  const { data: services = [] } = useListings("service");

  return (
    <Layout>
      <PageHeader eyebrow="Self-Care" title="Restore, in the finest hands." subtitle="Book spas, salons, fitness and wellness — reserved in moments." image="https://images.unsplash.com/photo-1720118509152-2df877673bee?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="selfcare-grid">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {services.map((s) => (
            <div key={s.id} data-testid={`service-card-${s.id}`} className="group flex flex-col sm:flex-row rounded-2xl overflow-hidden border border-white/10 hover:border-amber-400/40 transition-colors duration-500 bg-[#101017]">
              <div className="relative sm:w-2/5 h-52 sm:h-auto overflow-hidden"><img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
              <div className="p-6 flex flex-col justify-between flex-1">
                <div>
                  <span className="text-xs text-amber-400/80">{s.subtitle}</span>
                  <h3 className="font-serif text-xl text-white mt-1">{s.title}</h3>
                  {s.blurb && <p className="flex items-center gap-2 text-sm text-slate-400 mt-3"><Clock size={14} /> {s.blurb}</p>}
                </div>
                <div className="flex items-center justify-between mt-6">
                  <span className="text-champagne font-medium">{s.price}</span>
                  <div className="flex gap-2">
                    <button onClick={() => save({ item_type: "self-care", title: s.title, subtitle: s.subtitle, image: s.image, meta: { price: s.price, duration: s.blurb } })} data-testid={`save-service-${s.id}`} className="w-9 h-9 rounded-full border border-amber-400/30 flex items-center justify-center text-champagne hover:bg-amber-400/10 transition-colors duration-200"><Bookmark size={15} /></button>
                    <button onClick={() => toast.success("Booking request sent", { description: s.title })} data-testid={`book-service-${s.id}`} className="text-sm px-4 py-2 rounded-full bg-gradient-to-r from-[#F3E5AB] to-[#D4AF37] text-[#1a1a12] font-medium hover:opacity-90 transition-opacity duration-200">Book</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default SelfCare;
